import { escalaColumns } from '../../../components/escalaColumns'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { EscalaEmpresaActionsCell } from './EscalaEmpresaActionsCell'

/**
 * A listagem administrativa (`GET /escalas/empresa/{empresa}`, `findByEmpresa`)
 * mostra **apenas o que a empresa gerencia**. A indisponibilidade global do
 * profissional aparece no calendário, não aqui — é a decisão registrada na
 * revisão de arquitetura (§4 da revisão 2) e o motivo de a tela marcar aquele
 * bloco como não gerenciável em vez de oferecer editar/excluir.
 */
export const montaColunasEscalaEmpresa = (empresa: number) =>
  escalaColumns({
    useQueryRequest,
    renderActions: (escala) => <EscalaEmpresaActionsCell escala={escala} empresa={empresa} />,
  })
